import { combineReducers } from 'redux';
import {
  authReducer as auth,
  langReducer as lang,
  clinicalReportReducer as clinicalReport,
  customerReducer as customer,
  printJobReducer as printJob,
  userReducer as user,
  actionStackReducer as actionStack,
  searchReducer as search,
  autocompleteReducer as autocomplete,
  geneInformationReducer as geneInformation,
  tablesReducer as tables,
  staticContentReducer as staticContent,
  fileReducer as file,
  favoritesReducer as favorites,
  CLEAR_STATE
} from '@brightsolutionsgmbh/client-core';
import patientScopeSwitcher from './patientScopeSwitcher';

const appReducer = combineReducers({
  actionStack,
  auth,
  clinicalReport,
  customer,
  lang,
  autocomplete,
  search,
  user,
  geneInformation,
  printJob,
  staticContent,
  tables,
  file,
  favorites,
  patientScopeSwitcher
});

// wrapp combined reducers, this allows us to manipulate
// the global state when specific actions get fired
const rootReducer = (state, action) => {
  // catch logout action and clear global state
  if (action.type === CLEAR_STATE) {
    state = undefined;
  }

  const newState = appReducer(state, action);

  if (newState.lang && newState.lang.lang) {
    const currentLang = newState.lang.lang;
    if (!['en', 'de'].includes(currentLang)) {
      console.log(
        `Language '${currentLang}' is not supported, falling back to 'en'.`
      );
      return {
        ...newState,
        lang: {
          ...newState.lang,
          lang: 'en'
        }
      };
    }
  }

  return newState;
};

export default rootReducer;
